import { useEffect, useState } from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Avatar, Box, Button, Divider, Drawer, Hidden, Link, Typography } from '@material-ui/core';

import useAuth from '@hooks/useAuth';

import ChartSquareBarIcon from '@icons/ChartSquareBar';

import UsersIcon from '@icons/Users';

import AutoAwesomeIcon from '@material-ui/icons/AutoAwesome';
import SportsEsportsIcon from '@material-ui/icons/SportsEsports';
import BabyChangingStationIcon from '@material-ui/icons/BabyChangingStation';
import CampaignIcon from '@material-ui/icons/Campaign';

import Logo from '../Logo';
import NavSection from '../NavSection';
import Scrollbar from '../Scrollbar';
// import DynamicComponent from '@icons/ChartSquareBar';

const sections = [
  {
    title: 'General',
    items: [
      {
        title: 'Overview',
        path: '/',
        icon: <ChartSquareBarIcon fontSize="small" />
      }
    ]
  },
  {
    title: 'Management',
    items: [
      {
        title: '权限管理',
        icon: <AutoAwesomeIcon fontSize="small" />,
        path: '/dashboard/MenuManage',
        children: [
          {
            title: '菜单管理',
            path: '/dashboard/MenuManage'
          },
          {
            title: '用户管理',
            path: '/dashboard/UserManage'
          },
          {
            title: '角色管理',
            path: '/dashboard/RoleManage'
          },
          {
            title: '短信发送记录',
            path: '/dashboard/ShortMessage'
          },
          {
            title: 'app版本信息',
            path: '/dashboard/Edition'
          }
        ]
      },
      {
        title: '游戏管理',
        icon: <SportsEsportsIcon fontSize="small" />,
        path: '/dashboard/game',
        children: [
          {
            title: '游戏列表',
            path: '/dashboard/game/gameList'
          },
          {
            title: '游戏分类',
            path: '/dashboard/game/gameClassificationList'
          },
          {
            title: '关卡列表',
            path: '/dashboard/game/levelList'
          },
          {
            title: '游戏素材列表',
            path: '/dashboard/game/sourceList'
          },
          {
            title: '游戏反馈管理',
            path: '/dashboard/game/feedback'
          },
          {
            title: '游戏星星参数列表',
            path: '/dashboard/game/starsList'
          },
          {
            title: '激活码列表',
            path: '/dashboard/game/gameCodeList'
          },
          {
            title: 'pk赛体验码列表',
            path: '/dashboard/game/experienceCodeList'
          }
        ]
      },
      {
        title: '用户管理',
        icon: <UsersIcon fontSize="small" />,
        path: '/dashboard/userManage',
        children: [
          {
            title: '游戏用户列表',
            path: '/dashboard/userManage/GameUserList'
          },
          {
            title: '游戏解锁信息',
            path: '/dashboard/userManage/gameUsrKey'
          },
          {
            title: '用户游戏记录',
            path: '/dashboard/userManage/gameUsrList'
          },
          {
            title: '用户训练列表',
            path: '/dashboard/userManage/GameCampCust'
          },
          {
            title: '用户训练明细列表',
            path: '/dashboard/userManage/GameCampCustMoreList'
          },
          {
            title: '用户闯关历史记录列表',
            path: '/dashboard/userManage/GameUsrLevelHis'
          },
          {
            title: '用户闯关记录列表',
            path: '/dashboard/userManage/GameUsrLevel'
          }
        ]
      },
      {
        title: '训练营管理',
        icon: <CampaignIcon fontSize="small" />,
        path: '/dashboard/GameCamp',
        children: [
          {
            title: '训练营列表',
            path: '/dashboard/GameCamp'
          },
          {
            title: '训练营资料列表',
            path: '/dashboard/GameCampDoc'
          },
          {
            title: '训练营配置列表',
            path: '/dashboard/GameCampConfig'
          }
        ]
      }
    ]
  }
];

const DashboardSidebar = (props) => {
  const { onMobileClose, openMobile } = props;
  const location = useLocation();
  const { user = {}, menu } = useAuth();
  const [menus, setMenus] = useState([]);

  const converseToSection = (nodes, leader = false) => {
    let menus = [];
    if (nodes && typeof nodes === 'object')
      for (let node of nodes) {
        if (String(node.menuType) === '0') {
          const child = converseToSection(node.subMenus);
          if (leader) {
            nodes[0] === node &&
              menus.push({
                title: '菜单',
                items: []
              });
            menus[0].items.push({
              title: node.menuName,
              path: node.menuUrl,
              icon: node.menuIcon,
              children: child
            });
          } else {
            menus.push({
              title: node.menuName,
              path: node.menuUrl,
              icon: node.menuIcon,
              children: child.length === 0 ? undefined : child
            });
          }
        }
      }
    return menus;
  };

  useEffect(() => {
    if (openMobile && onMobileClose) {
      onMobileClose();
    }
    setMenus([
      {
        title: 'General',
        items: [
          {
            title: '首页',
            path: '/',
            icon: 'ChartSquareBarIcon'
          }
        ]
      },
      ...converseToSection(menu, true)
    ]);
  }, [location.pathname]);

  const content = (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%'
      }}
    >
      <Scrollbar options={{ suppressScrollX: true }}>
        <Hidden lgUp>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              p: 2
            }}
          >
            <RouterLink to="/">
              <Logo
                sx={{
                  height: 40,
                  width: 40
                }}
              />
            </RouterLink>
          </Box>
        </Hidden>
        <Box sx={{ p: 2 }}>
          <Box
            sx={{
              alignItems: 'center',
              backgroundColor: 'background.default',
              borderRadius: 1,
              display: 'flex',
              overflow: 'hidden',
              p: 2
            }}
          >
            <RouterLink to="/dashboard/account">
              <Avatar
                src="/static/mock-images/covers/cover_6.jpeg"
                sx={{
                  cursor: 'pointer',
                  height: 48,
                  width: 48
                }}
              />
            </RouterLink>
            <Box sx={{ ml: 2 }}>
              <Typography color="textPrimary" variant="subtitle2">
                {user.userName}
              </Typography>
              <Typography color="textSecondary" variant="body2">
                角色:{' '}
                <Link color="primary" component={RouterLink} to="/pricing">
                  {user.roles}
                </Link>
              </Typography>
            </Box>
          </Box>
        </Box>
        <Divider />
        <Box sx={{ p: 2 }}>
          {menus.map((section) => (
            <NavSection
              key={section.title}
              pathname={location.pathname}
              sx={{
                '& + &': {
                  mt: 3
                }
              }}
              {...section}
            />
          ))}
        </Box>
      </Scrollbar>
    </Box>
  );

  return (
    <>
      <Hidden lgUp>
        <Drawer
          anchor="left"
          onClose={onMobileClose}
          open={openMobile}
          PaperProps={{
            sx: {
              backgroundColor: 'background.paper',
              width: 280
            }
          }}
          variant="temporary"
        >
          {content}
        </Drawer>
      </Hidden>
      <Hidden lgDown>
        <Drawer
          anchor="left"
          open
          PaperProps={{
            sx: {
              backgroundColor: 'background.paper',
              height: 'calc(100% - 64px) !important',
              top: '64px !Important',
              width: 280
            }
          }}
          variant="persistent"
        >
          {content}
        </Drawer>
      </Hidden>
    </>
  );
};

DashboardSidebar.propTypes = {
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool
};

export default DashboardSidebar;
